import {
    ChangeDetectionStrategy,
    Component,
    ComponentRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
    input,
    inject,
    ViewContainerRef,
} from '@angular/core';
import { BazisContextMenuService } from '@bazis/shared/services/context-menu.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'bazis-context-menu',
    templateUrl: './context-menu.component.html',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent implements OnInit, OnDestroy {
    public contextMenuService = inject(BazisContextMenuService);

    readonly contextMenu = input<any>(undefined);

    @ViewChild('componentHost', { read: ViewContainerRef, static: true })
    componentHost!: ViewContainerRef;

    @HostListener('document:keydown.escape') onKeydownHandler() {
        if (this.contextMenu().options.keyboardClose) {
            this.close();
        }
    }

    componentRef: ComponentRef<any>;

    ngOnInit(): void {
        this.loadComponent();
    }

    ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    close() {
        if (this.componentRef.instance.close) {
            this.componentRef.instance.close();
        } else {
            this.contextMenuService.dismiss(null, this.contextMenu());
        }
    }

    loadComponent() {
        const component = this.contextMenu().options.component;
        this.componentHost.clear();
        this.componentRef = this.componentHost.createComponent(component);
        const contextMenu = this.contextMenu();
        if (contextMenu.options.componentProperties) {
            Object.keys(contextMenu.options.componentProperties).forEach((key) => {
                this.componentRef.instance[key] =
                    this.contextMenu().options.componentProperties[key];
            });
        }
    }
}
